import React, { useState, useEffect } from 'react';
import './DigitalLibrary.css';
import book2 from "../assets/Book2.webp";
import englishgrammer from "../assets/BasicEnglishGrammar.webp";
import ncert from "../assets/NCERT-Book.webp";
import audio from "../assets/Audio.webp";
import epathshala from "../assets/EPathshala.webp"; 
import akbar from "../assets/Kids1.webp";
import Tanali from "../assets/Kids6.webp";
import PanchTantra from "../assets/Kids3.webp";
import SleepingBeauty from "../assets/Kids5.webp"; 
import financial1 from "../assets/FinancialLiteracy6.webp";
import financial2 from "../assets/FinancialLiteracy7.webp";
import financial3 from "../assets/FinancialLiteracy8.webp";
import financial4 from "../assets/FinancialMarkets9.webp"; 
import hindi6 from "../assets/GulmoharHindiVyakaran6-02.webp";
import hindi7 from "../assets/GulmoharHindiVyakaran7-02.webp";
import hindi8 from "../assets/GulmoharHindiVyakaran8-02.webp";
import vyakran910 from "../assets/Vyakaran-Prakash-9-10-A-02.webp";
import vyakran10 from "../assets/Vyakaran-Pravah-10-A.webp";

const DigitalLibrary = () => {
  const [isPageVisible, setIsPageVisible] = useState(false);

  useEffect(() => {
    setIsPageVisible(true);
  }, []);

  // Featured NCERT collection with links
  const featuredBooks = [
    {
      id: 'ncert-books',
      title: 'NCERT-Books',
      description: 'Access digital books',
      image: ncert,
      url: 'https://ncert.nic.in/textbook.php'
    },
    {
      id: 'ncert-audio',
      title: 'NCERT-Audio Books',
      description: 'Listen & learn',
      image: audio,
      url: 'https://ciet.ncert.gov.in/audio-books'
    },
    {
      id: 'epathshala',
      title: 'NCERT-Epathshala',
      description: 'Learning on the go',
      image: epathshala,
      url: 'https://epathshala.nic.in/process.php?id=students&type=eTextbooks&ln=en'
    }
  ];

  const collectionData = [
    {
      titleText: 'English Grammar - Digital Collection',
      itemsList: [
        { 
          itemId: 1, 
          itemTitle: 'English Grammar-Books1', 
          itemImage: book2,
          itemUrl: 'https://drive.google.com/file/d/17eXJ9Ff7RWhkEYq1pHuB1S_vKyjbqKCl/view'
        },
        { 
          itemId: 2, 
          itemTitle: 'English Grammar- Books2', 
          itemImage: englishgrammer,
          itemUrl: 'https://drive.google.com/file/d/1MwjJYiKFBa2KSRKDHcCLvPhuEGRh1Z0M/view'
        }
      ]
    },
    {
      titleText: 'Kids World - Digital Collection',
      itemsList: [
        { 
          itemId: 3, 
          itemTitle: 'STORY-Akabar Birbal', 
          itemImage: akbar,
          itemUrl: 'https://drive.google.com/file/d/1fQZli1z88lvEoiSYTUWZwVfrj-xrqIDE/view'
        },
        { 
          itemId: 4, 
          itemTitle: 'STORY-Tanali Raman', 
          itemImage: Tanali,
          itemUrl: 'https://drive.google.com/file/d/192Med7Y38oLegGPoIu2COXF7AK4UINB9/view'
        },
        { 
          itemId: 5, 
          itemTitle: 'STORY-PanchTantra', 
          itemImage: PanchTantra,
          itemUrl: 'https://www.example.com/panchatantra-stories'
        },
        { 
          itemId: 6, 
          itemTitle: 'STORY-Sleeping Beauty', 
          itemImage: SleepingBeauty,
          itemUrl: 'https://drive.google.com/file/d/1cPNC-N5zqQ2Nd6ocdPkINOhOZwHOn80D/view'
        }
      ]
    },
    {
      titleText: 'CBSC Skill Subjects - Digital Collection',
      itemsList: [
        { 
          itemId: 7, 
          itemTitle: 'SUBJECT-Financial Literacy 6', 
          itemImage: financial1,
          itemUrl: 'https://pubhtml5.com/dgzg/kisc/'
        },
        { 
          itemId: 8, 
          itemTitle: 'SUBJECT-Financial Literacy 7', 
          itemImage: financial2,
          itemUrl: 'https://pubhtml5.com/dgzg/xjhh/'
        },
        { 
          itemId: 9, 
          itemTitle: 'SUBJECT-Financial Literacy 8', 
          itemImage: financial3,
          itemUrl: 'https://pubhtml5.com/dgzg/cbop/'
        },
        { 
          itemId: 10, 
          itemTitle: 'SUBJECT-Financial Markets 9', 
          itemImage: financial4,
          itemUrl: 'https://pubhtml5.com/dgzg/kvwi/'
        }
      ]
    },
    {
      titleText: 'Hindi Vyakaran - Digital Collection',
      itemsList: [
        { 
          itemId: 11, 
          itemTitle: 'Gulmohar Hindi Grammar Ver. 3 Class 6', 
          itemImage: hindi6,
          itemUrl: 'https://www.fullmarksonline.com/Teachers/viewFullBook/IyxTPFcKYAo='
        },
        { 
          itemId: 12, 
          itemTitle: 'Gulmohar Hindi Grammar Ver. 3 Class 7', 
          itemImage: hindi7,
          itemUrl: 'https://www.fullmarksonline.com/Teachers/viewFullBook/Iy0jOFgKYAo='
        },
        { 
          itemId: 13, 
          itemTitle: 'Gulmohar Hindi Grammar Ver. 3 Class 8', 
          itemImage: hindi8,
          itemUrl: 'https://www.fullmarksonline.com/Teachers/viewFullBook/Iy0jOFkKYAo='
        },
        { 
          itemId: 14, 
          itemTitle: 'Vyakaran Prakash For Class 9-10 Course A', 
          itemImage: vyakran910,
          itemUrl: 'https://www.fullmarksonline.com/Teachers/viewFullBook/Iy0jOFcKYAo='
        },
        { 
          itemId: 15, 
          itemTitle: 'Vyakaran Pravah Class 10 Course A', 
          itemImage: vyakran10,
          itemUrl: 'https://www.fullmarksonline.com/Teachers/viewFullBook/IywzMFYKYAo='
        }
      ]
    }
  ];

  return (
    <div className={`digilib-container ${isPageVisible ? 'digilib-show' : ''}`}>
      
        {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>B.C.A - DIGITAL LIBRARY</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Digital Library</li>
          </ul>
        </div>
      </section>

      <div className="digilib-featured-section">
        <h2 className="digilib-category-title">
          <span className="digilib-title-icon">📖</span>
          NCERT-Digital Collection
        </h2>
        <div className="digilib-featured-grid">
          {featuredBooks.map((book) => (
            <a 
              key={book.id}
              href={book.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`digilib-featured-box digilib-box-${book.id === 'ncert-books' ? 'one' : book.id === 'ncert-audio' ? 'two' : 'three'}`}
              style={{ textDecoration: 'none' }}
            >
              <div className="digilib-box-inner">
                <div className="digilib-box-image-container">
                  <img 
                    src={book.image}
                    alt={book.title} 
                    className="digilib-box-image"
                  />
                </div>
                <h3 className="digilib-box-title">{book.title}</h3>
                <p className="digilib-box-desc">{book.description}</p>
                <div className="digilib-image-overlay">
                  <span className="digilib-box-view-btn">View Books</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>

      {collectionData.map((collection, idx) => (
        <div key={idx} className="digilib-books-section" style={{ animationDelay: `${idx * 0.15}s` }}>
          <h2 className="digilib-category-title">
            <span className="digilib-title-icon">📚</span>
            {collection.titleText}
          </h2>
          <div className="digilib-items-container">
            {collection.itemsList.map((book, bookIdx) => (
              <a
                key={book.itemId}
                href={book.itemUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="digilib-book-card"
                style={{ 
                  animationDelay: `${(idx * 0.15) + (bookIdx * 0.08)}s`,
                  textDecoration: 'none'
                }}
              >
                <div className="digilib-card-inner">
                  <div className="digilib-image-box">
                    <img src={book.itemImage} alt={book.itemTitle} className="digilib-book-image" />
                    <div className="digilib-image-overlay">
                      <span className="digilib-view-btn">View Book</span>
                    </div>
                  </div>
                  <div className="digilib-card-info">
                    <p className="digilib-book-title">{book.itemTitle}</p>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DigitalLibrary;